import React from "react";
import { faEyeSlash, faLayerGroup, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import "components/cards/removableCard/removableCard.scss";
import "./multipleDragCardView.scss";

export interface MultipleDragCardViewProps {
  count: number;
  isReadOnly?: boolean;
  hidden?: boolean;
}

const MultipleDragCardView: React.FC<MultipleDragCardViewProps> = ({ count, hidden }) => {
  const icon = !hidden ? <FontAwesomeIcon icon={faLayerGroup} /> : <FontAwesomeIcon icon={faEyeSlash} />;

  return (
    <div className="removable-card multiple-drag-card-view">
      <div className="stacked-cards">
        <div className="card-layer card-layer-1" />
      </div>

      <div className="main-card">
        <div className="image">
          <div className={cn("removable-card-icon-background", { hiddenCardOverlay: !!hidden })}>{icon}</div>
          <div className="count-badge">{count}</div>
        </div>
        <div className="content">
          <div className="title">
            <span>Multiple assets selected</span>
          </div>
          <div className="meta-text">Drag to add to pack</div>
        </div>
      </div>
      <div className="remove-icon">
        <FontAwesomeIcon icon={faTimes} />
      </div>
    </div>
  );
};

export default MultipleDragCardView;
